import { type ReactNode, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { formatUSD } from '../utils/payment-formatters';
import type { CycleTotal } from '../hooks/use-cycle-totals';
import { CycleBreakdownDetail } from './cycle-breakdown-detail';

const TD = 'py-3 align-middle';

function fmtDate(d: string): string {
  return d.slice(5, 10).replace('-', '/');
}

function MainRowCells({ c, open }: { c: CycleTotal; open: boolean }): ReactNode {
  const chev = `transition-transform ${open ? 'rotate-180' : ''}`;
  return (
    <>
      <td className={`${TD} pr-md text-[11px] tabular-nums text-text-tertiary`}>
        {fmtDate(c.period_start)}–{fmtDate(c.period_end)}
      </td>
      <td className={`${TD} pr-md text-[11px] tabular-nums text-text-secondary`}>
        {c.collectors_count}
      </td>
      <td className={`${TD} pr-md font-mono text-xs tabular-nums text-text-primary`}>
        {formatUSD(c.total_eur)}
      </td>
      <td className={`${TD} w-6 text-text-tertiary`}>
        <ChevronDown size={14} className={chev} />
      </td>
    </>
  );
}

function MainRow(p: {
  c: CycleTotal;
  open: boolean;
  onToggle: () => void;
}): ReactNode {
  return (
    <tr
      className="cursor-pointer border-t border-white/[0.06] transition-colors hover:bg-white/[0.02]"
      onClick={p.onToggle}
    >
      <MainRowCells c={p.c} open={p.open} />
    </tr>
  );
}

export function InvestmentHistoryRow({ c }: { c: CycleTotal }): ReactNode {
  const [open, setOpen] = useState(false);
  return (
    <>
      <MainRow c={c} open={open} onToggle={() => setOpen((v) => !v)} />
      {open && <CycleBreakdownDetail c={c} />}
    </>
  );
}
